module.exports = __webpack_public_path__ + "img/CJ.333dada2.png";